/**
 * Analytics no-op shim.
 *
 * External analytics (`@vercel/analytics`) was removed when the studio
 * dropped third-party sub-processors. The `track()` export is preserved
 * with its original signature so existing callers keep compiling — every
 * call is now a silent no-op.
 *
 * UTM attribution is still captured locally (see `./utm.ts`) for use by
 * the contact form and any future first-party analytics sink. The
 * `getAttribution` re-export below keeps that surface accessible from
 * `lib/analytics.js` for callers that imported it from here.
 */

import { getAttribution as _getAttribution, type Attribution } from "./utm.js";

export type { Attribution };

/**
 * Track a custom event. No-op since external analytics was removed.
 * Signature preserved so existing call sites keep type-checking.
 */
export function track(
  _event: string,
  _props: Record<string, unknown> = {},
): void {
  // no-op: external analytics removed.
}

/** Re-export of the local UTM attribution reader for backwards compat. */
export const getAttribution = _getAttribution;
